import type { IconSvgObject } from './types';

const SlidersVerticalIcon: IconSvgObject = [
  ["path", { d: "M5.00018 20.0001L4.99994 14.0001", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.99994 11.0001V4.00006", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.99994 8.00006H14.9999", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M1.99994 14.0001H7.99994", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M15.9999 12.0001H21.9999", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M11.9997 8.00006L11.9999 4.00006", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "5" }],
  ["path", { d: "M12.0002 20.0001L11.9999 11.0001", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "6" }],
  ["path", { d: "M18.9999 12.0001L18.9999 4.00006", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "7" }],
  ["path", { d: "M19.0002 20.0001L18.9999 15.0001", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "8" }]
];

export default SlidersVerticalIcon;
